export default {
  title: 'Account beheren',
  buttons: {
    save: 'Opslaan',
    delete: 'Verwijderen',
  },
};
